export function initContactFormTabs() {
  const containers = document.querySelectorAll('[data-contact-form-tabs]');
  if (!containers.length) return;

  containers.forEach((container) => {
    const tabs = Array.from(container.querySelectorAll('[data-contact-form-tab]'));
    const panels = Array.from(container.querySelectorAll('[data-contact-form-panel]'));
    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      tab.tabIndex = 0;
    });
    panels.forEach((panel) => {
      panel.classList.remove('is-active');
      panel.hidden = true;
    });

    const assignIconVariants = () => {
      panels.forEach((panel) => {
        const panelId = panel.getAttribute('data-contact-form-panel');
        if (!panelId) return;

        const tab = tabs.find((t) => t.getAttribute('data-contact-form-tab') === panelId);
        if (!tab) return;

        const formEl = panel.querySelector('form.powermail_form');
        let variant = null;

        if (formEl) {
          const cls = formEl.className || '';
          if (cls.includes('layout2')) variant = 'layout2';
          else if (cls.includes('layout1')) variant = 'layout1';
        }

        if (variant) {
          tab.dataset.iconVariant = variant;
        } else {
          delete tab.dataset.iconVariant;
        }
      });
    };

    assignIconVariants();

    const activateTab = (targetTab) => {
      const targetId = targetTab.getAttribute('data-contact-form-tab');
      if (!targetId) return;

      tabs.forEach((tab) => {
        const isActive = tab === targetTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-contact-form-panel') === targetId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (!(event instanceof KeyboardEvent)) return;
        const currentIndex = tabs.indexOf(tab);
        if (currentIndex < 0) return;

        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
          const nextTab = tabs[nextIndex];
          if (nextTab) {
            activateTab(nextTab);
            nextTab.focus();
          }
        }
      });
    });
  });
}
